import CommonService from '@src/service/commonService'
import {Button, Loading, Mask, Space, TextArea, Toast} from 'antd-mobile'
import {CloseOutline} from 'antd-mobile-icons'
import {ReactNode, useEffect, useState} from 'react'
import './index.scss'
import {isEmpty} from "@src/util";

type Diff<T extends keyof any, U extends keyof any> = ({ [P in T]: P } & {
	[P in U]: never
} & { [x: string]: never })[T]
type Overwrite<T, U> = Pick<T, Diff<keyof T, keyof U>> & U

interface NormalModalProps {
	visible: boolean
	onOk: () => void
	onCancel?: () => void
	okText?: string
	cancelText?: string
}

interface BaseModalProps extends NormalModalProps {
	needCancel?: boolean
	title?: ReactNode | string
	content: ReactNode | string
}

const BaseModal = ({
					   visible,
					   onOk,
					   onCancel,
					   needCancel = true,
					   title = '标题',
					   content,
					   okText = '确认',
					   cancelText = '取消',
				   }: BaseModalProps) => {
	return (
		<Mask
			visible={visible}
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<div className="base-box">
				{title && <div className="box-title">{title}</div>}
				<div className="box-content">{content}</div>
				<Space style={{'--gap': '34px', width: '100%'}} justify="center">
					{needCancel && (
						<Button className="btn btn-cancel" onClick={() => onCancel?.()}>
							{cancelText}
						</Button>
					)}
					<Button
						className="btn btn-ok"
						onClick={() => onOk()}
						style={{background: '#6291df'}}
					>
						{okText}
					</Button>
				</Space>
			</div>
		</Mask>
	)
}

export const AlertModal = (props: BaseModalProps) => {
	return <BaseModal {...props} needCancel={false}/>
}
export const ConfirmModal = ({
								 visible,
								 onOk,
								 onCancel,
								 content,
								 okText = '确认',
								 cancelText = '取消',
							 }: NormalModalProps & { content: string }) => {
	return (
		<Mask
			visible={visible}
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<div className="base-box">
				<div
					style={{
						textAlign: 'center',
						marginTop: 30,
						fontSize: 16,
						color: '#fff',
					}}
				>
					{content}
				</div>
				<Space
					style={{'--gap': '20px', width: '100%', marginTop: 80}}
					justify="center"
				>
					<Button className="btn btn-cancel" onClick={() => onCancel?.()}>
						{cancelText}
					</Button>

					<Button
						className="btn btn-ok"
						onClick={() => onOk()}
						style={{background: '#6291df'}}
					>
						{okText}
					</Button>
				</Space>
			</div>
		</Mask>
	)
}

interface PushConfirmModalProps {
	onOk: (value: string) => void
}

export const PushConfirmModal = ({
									 onOk,
									 ...rest
								 }: Overwrite<NormalModalProps, PushConfirmModalProps>) => {
	const [v, setV] = useState('')
	const save = () => {
		if (!v) {
			Toast.show('请输入原因，不可提交')
			return
		}
		onOk(v)
	}
	return (
		<BaseModal
			{...rest}
			onOk={save}
			title="终止"
			content={
				<>
					<div className="push-text">
						确定终止该申请？终止后需从金融方案确认重新开始走流程。确认终止请输入原因：
					</div>
					<TextArea
						placeholder="请输入原因"
						value={v}
						onChange={(val) => {
							setV(val)
						}}
						style={{
							'--color': '#fff',
							background: 'rgba(255, 255, 255, 0.27)',
							padding: 8,
							borderRadius: 4,
							fontSize: 15,
						}}
					/>
				</>
			}
		/>
	)
}

interface PersonSelectProps
	extends Overwrite<NormalModalProps, PushConfirmModalProps> {
	title?: string
	labelText?: string
}

export const PersonSelect = ({
								 visible,
								 onOk,
								 onCancel,
								 okText = '确认',
								 cancelText = '取消',
								 title = '指派',
								 labelText = '指派给',
							 }: PersonSelectProps) => {
	const [list, setList] = useState([])
	const [filterList, setFilterList] = useState<Array<{label:string,id:number}>>([])
	const [value, setValue] = useState('')
	const [filterShow, setFilterShow] = useState(false)
	useEffect(() => {
		if (visible) {
			CommonService.getAsignManageList({salesType: 1}).then((res: any) => {
				setList(res || [])
			})
		}
	}, [])

	function getList() {
		let _list = list.map((item: { name: string, phone: string, id:number }) => ({label:`${item.name}-${item.phone}`, id:item.id}))
		if (isEmpty(value)) {
			return _list;
		}
		// todo 过滤
		_list = _list.filter(l => l.label.indexOf(value) >= 0)
		return _list;
	}

	useEffect(() => {
		const _list = getList()
		setFilterList(_list)
	}, [value])

	const getId = (val: string) => {
		// const [name, phone] = val.split('-')
		const _list = list.map((item: { name: string, phone: string, id:number }) => ({label:`${item.name}-${item.phone}`, id:item.id}))
		const result: any = _list.find(
			(item: any) => item.label == val //item.name === name && item.phone === phone
		)

		return result?.id || ''
	}

	const save = () => {
		if (!value) {
			Toast.show({
				content: '请选择销售',
			})
			return
		}
		const id = getId(value)
		if(isEmpty(id)){
			Toast.show({
				content:'该销售数据异常！'
			})
			return
		}
		onOk(id)
	}
	return (
		<Mask
			visible={visible}
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
			onMaskClick={e => {
				const target: any = e.target
				if (target.tagName != 'INPUT' && target.className.indexOf('item') < 0) {
					// 当事件触发不在选项上时
					setFilterShow(false)
				}
			}}
		>
			<div className="base-box">
				<Space
					style={{width: '100%', color: '#fff', fontSize: 16}}
					justify="between"
				>
					<div>{title}</div>
					<CloseOutline onClick={() => onCancel?.()}/>
				</Space>
				<Space
					style={{
						width: '100%',
						color: '#fff',
						fontSize: 16,
						marginTop: 20,
						marginBottom: 40,
					}}
					align="center"
				>
					<div>{labelText}：</div>
					<div className="name-input">
						<input value={value}
							   onFocus={() => {
								   const _list = getList()
								   setFilterList(_list)
								   setFilterShow(true)
							   }}
							   onChange={(e) => setValue(e.target.value)}
						/>
						{
							filterShow && filterList && filterList.length > 0 && <div className="data-list">
								{
									filterList.map((item, index) => {
										return <div key={index} className="item" onClick={() => {
											setValue(item.label)
											setFilterShow(false)
										}}>{item.label}</div>
									})
								}
							</div>
						}
					</div>
				</Space>
				<Space style={{'--gap': '34px'}}>
					<Button className="btn btn-cancel" onClick={() => onCancel?.()}>
						{cancelText}
					</Button>
					<Button className="btn btn-ok" onClick={save}>
						{okText}
					</Button>
				</Space>
			</div>
		</Mask>
	)
}

export const LoadingModal = ({visible, text}: any) => {
	return (
		<Mask
			visible={visible}
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<div style={{color: '##fff', fontSize: 20}}>
				<Loading color="white"/>
				<span>{text}</span>
			</div>
		</Mask>
	)
}
